
import * as React from 'react';
import { ControlHandlerProvider, IControlFaceted } from '../decorators/withControlHandler';
import { itemCacheSuspenseControl, ItemCacheSuspenseMode } from '../../controls/itemCacheSuspenseControl';
import { IItemCache } from '../../models/IItemCacheObserver';

const controlHandlersByMode: {
  [P in ItemCacheSuspenseMode]: typeof itemCacheSuspenseControl.type;
} = {
  debounce: (
    // Never used.
    itemCache: IItemCache,
    props: typeof itemCacheSuspenseControl.inputType
  ): typeof itemCacheSuspenseControl.returnType => {
    if (props.mode) {
      // If a closer ItemCacheSuspense applies to a component, prefer it instead of overriding.
      return {};
    }

    return {
      mode: 'debounce'
    };
  }
};

export interface IItemCacheSuspenseProps {
  mode: ItemCacheSuspenseMode;
}

export class ItemCacheSuspense extends React.PureComponent<IItemCacheSuspenseProps> {
  private _controlHandlers: IControlFaceted;

  constructor(props: IItemCacheSuspenseProps) {
    super(props);

    this._controlHandlers = itemCacheSuspenseControl.pack(controlHandlersByMode[props.mode]);
  }

  public render(): JSX.Element {
    return (
      <ControlHandlerProvider
        controlHandlers={ this._controlHandlers }
      >
        { this.props.children }
      </ControlHandlerProvider>
    );
  }
}
